import React from 'react'
import { colors, borderRadius } from '../../styles/tokens'
import { formatFullDate, formatPrice, formatPassengers } from '../../utils/formatters'
import BlockPreview from './BlockPreview'

/**
 * Preview completo da cotação com confirmação
 * 
 * Single Responsibility: Exibir preview e permitir confirmação
 * 
 * NOTA: Campo de correção por IA foi movido para o QuoteEditor (pós-publicação).
 * Props correction/setCorrection/refining/onCorrection mantidas por contrato
 * mas não renderizam UI — falseia para não quebrar nenhum import.
 */
export default function AssistantPreview({
  preview,
  clientName,
  setClientName,
  correction,       // mantido por contrato (não usado)
  setCorrection,    // mantido por contrato (não usado)
  refining,         // mantido por contrato (não usado)
  loading,
  onCorrection,     // mantido por contrato (não usado)
  onConfirm,
  onReset
}) {
  const passengersText = formatPassengers(
    preview?.adults,
    preview?.children,
    preview?.infants
  )

  return (
    <div style={{
      padding: '1.5rem',
      borderBottom: `1px solid ${colors.border}`,
      backgroundColor: 'rgba(16, 185, 129, 0.05)'
    }}>
      <p style={{ margin: '0 0 1rem', color: colors.text.primary, fontWeight: 500 }}>
        ✅ Pronto! Confira os detalhes da cotação:
      </p>

      <div style={{
        backgroundColor: colors.card,
        borderRadius: borderRadius.md,
        padding: '1.5rem',
        border: `1px solid ${colors.border}`
      }}>
        {/* Cabeçalho */}
        <div style={{
          marginBottom: '1.5rem',
          paddingBottom: '1rem',
          borderBottom: `1px solid ${colors.border}`
        }}>
          <div style={{ fontSize: '1.25rem', fontWeight: 600, color: colors.text.primary }}>
            📍 {preview.destination || 'Destino'}
          </div>
          <div style={{ fontSize: '0.9rem', color: colors.text.secondary, marginTop: '0.5rem' }}>
            📅 {formatFullDate(preview.start_date)} - {formatFullDate(preview.end_date)}
            {' • '}
            👥 {passengersText}
          </div>
          <div style={{ fontSize: '1.1rem', fontWeight: 600, color: colors.primary, marginTop: '0.5rem' }}>
            💰 {formatPrice(preview.total_price)}
          </div>
        </div>

        {/* Blocos detalhados */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {(preview.blocks || []).map((block, i) => (
            <BlockPreview key={i} block={block} />
          ))}
        </div>
      </div>



      {/* Botões de ação */}
      <div style={{ marginTop: '1.5rem', display: 'flex', gap: '0.75rem' }}>
        <button
          onClick={onConfirm}
          disabled={loading}
          style={{
            flex: 1,
            padding: '0.875rem 1.5rem',
            backgroundColor: (!clientName.trim() || loading) ? '#ccc' : '#10b981',
            color: 'white',
            border: 'none',
            borderRadius: borderRadius.md,
            fontWeight: 500,
            fontSize: '1rem',
            cursor: (!clientName.trim() || loading) ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? '⏳ Verificando imagens...' : '✅ Confirmar e criar cotação'}
        </button>
        <button
          onClick={onReset}
          disabled={loading}
          style={{
            padding: '0.875rem 1.5rem',
            backgroundColor: 'transparent',
            color: colors.text.secondary,
            border: `1px solid ${colors.border}`,
            borderRadius: borderRadius.md,
            fontWeight: 500,
            cursor: 'pointer'
          }}
        >
          🔄 Recomeçar
        </button>
      </div>
    </div>
  )
}
